(function () {
  if (window.__gs366StoryLoaded) return;
  window.__gs366StoryLoaded = true;

  function initGs366Section(section) {
    if (!section || section.dataset.gs366Ready === 'true') return;
    section.dataset.gs366Ready = 'true';

    var targets = Array.prototype.slice.call(section.querySelectorAll('[data-gs-reveal]'));
    if (!targets.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      targets.forEach(function (target) { target.classList.add('is-visible'); });
      return;
    }

    section.classList.add('is-motion-ready');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

    targets.forEach(function (target) { observer.observe(target); });
  }

  function initGs366Carousel(shell) {
    if (!shell || shell.dataset.gsCarouselReady === 'true') return;
    var track = shell.querySelector('[data-gs-carousel-track]');
    if (!track) return;

    shell.dataset.gsCarouselReady = 'true';
    var enabled = shell.dataset.sliderEnabled !== 'false';
    var previous = shell.querySelector('[data-gs-carousel-prev]');
    var next = shell.querySelector('[data-gs-carousel-next]');
    var navigation = shell.querySelector('[data-gs-carousel-nav]');
    var frame = 0;
    var dragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;

    function visibleCards() {
      return Array.prototype.slice.call(track.querySelectorAll('.gs366-story-card')).filter(function (card) {
        return card.offsetParent !== null;
      });
    }

    function scrollStep() {
      var cards = visibleCards();
      if (!cards.length) return Math.max(track.clientWidth, 1);
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');
      return cards[0].getBoundingClientRect().width + gap;
    }

    function updateControls() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var hasOverflow = enabled && maxScroll > 2;
      if (navigation) navigation.hidden = navigation.dataset.show === 'false' || !hasOverflow;
      if (previous) previous.disabled = !hasOverflow || track.scrollLeft <= 2;
      if (next) next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
      track.setAttribute('aria-roledescription', hasOverflow ? 'carousel' : 'list');
    }

    function move(direction) {
      if (!enabled) return;
      track.scrollBy({ left: direction * scrollStep(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });

    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    });

    track.addEventListener('scroll', function () {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateControls);
    }, { passive: true });

    if (enabled && shell.dataset.mouseDrag === 'true') {
      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        shell.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
      });

      function stopDrag(event) {
        if (!dragging) return;
        dragging = false;
        shell.classList.remove('is-dragging');
        if (event && track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      }

      track.addEventListener('pointerup', stopDrag);
      track.addEventListener('pointercancel', stopDrag);
      track.addEventListener('lostpointercapture', function () {
        dragging = false;
        shell.classList.remove('is-dragging');
      });
    }

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(updateControls);
      resizeObserver.observe(track);
      shell._gs366ResizeObserver = resizeObserver;
    } else {
      window.addEventListener('resize', updateControls, { passive: true });
    }

    updateControls();
  }

  function initGs366Scenes(section) {
    if (!section || section.dataset.gsScenesReady === 'true') return;
    var track = section.querySelector('[data-gs-scenes-track]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-gs-scene-slide]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-gs-scenes-dot]'));
    if (!track || slides.length < 2) return;

    section.dataset.gsScenesReady = 'true';
    var activeIndex = 0;
    var scrollFrame = 0;
    var timer = null;
    var autoplay = section.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = Math.max(3000, parseInt(section.dataset.interval || '6000', 10));

    function setActive(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach(function (dot, dotIndex) {
        dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
    }

    function goTo(index, behavior) {
      var nextIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: nextIndex * track.clientWidth, behavior: behavior || 'smooth' });
      setActive(nextIndex);
    }

    function stopTimer() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startTimer() {
      stopTimer();
      if (!autoplay || document.hidden) return;
      timer = window.setInterval(function () { goTo(activeIndex + 1); }, interval);
    }

    track.addEventListener('scroll', function () {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        setActive(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
      });
    }, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.gsScenesDot || '0', 10));
        startTimer();
      });
    });

    var previous = section.querySelector('[data-gs-scenes-prev]');
    var next = section.querySelector('[data-gs-scenes-next]');
    if (previous) previous.addEventListener('click', function () { goTo(activeIndex - 1); startTimer(); });
    if (next) next.addEventListener('click', function () { goTo(activeIndex + 1); startTimer(); });

    section.addEventListener('pointerenter', stopTimer);
    section.addEventListener('pointerleave', startTimer);
    section.addEventListener('focusin', stopTimer);
    section.addEventListener('focusout', startTimer);
    document.addEventListener('visibilitychange', startTimer);
    setActive(0);
    startTimer();
  }

  function syncGs366Videos(root) {
    (root || document).querySelectorAll('.gs366-responsive-media[data-video-autoplay] video').forEach(function (video) {
      var container = video.closest('.gs366-responsive-media');
      var shouldPlay = container && container.dataset.videoAutoplay === 'true' && container.offsetParent !== null && !document.hidden;
      if (shouldPlay) {
        video.muted = true;
        video.playsInline = true;
        if (video.paused) {
          var promise = video.play();
          if (promise && typeof promise.catch === 'function') promise.catch(function () {});
        }
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  var videoSyncFrame = 0;
  function scheduleVideoSync() {
    if (videoSyncFrame) window.cancelAnimationFrame(videoSyncFrame);
    videoSyncFrame = window.requestAnimationFrame(function () {
      videoSyncFrame = 0;
      syncGs366Videos(document);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.gs366-section').forEach(initGs366Section);
    (root || document).querySelectorAll('[data-gs-carousel]').forEach(initGs366Carousel);
    (root || document).querySelectorAll('[data-gs-scenes]').forEach(initGs366Scenes);
    syncGs366Videos(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-gs-carousel]').forEach(function (shell) {
      if (shell._gs366ResizeObserver) shell._gs366ResizeObserver.disconnect();
    });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    var track = block && block.closest ? block.closest('[data-gs-carousel-track]') : null;
    if (track && block.scrollIntoView) block.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
  window.addEventListener('resize', scheduleVideoSync, { passive: true });
  document.addEventListener('visibilitychange', scheduleVideoSync);
})();
